import React, { Component } from 'react';
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import { Link } from 'react-router-dom';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import FloatingWhatsApp from '../componentes/WhatsAppFlutuante';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { scrollToTop } from '../utils/scrollUtils';
import { fetchRevenda, subscribeToCollection } from '../utils/firestoreUtils';
import { id_firebase } from '../content-site';
import veiculoUtils from '../utils/infoSubmitVeiculos';
import { formatCambio, formatMoney } from '../utils/formatUtils';

class Inicio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            veiculos: [],
            veiculosComplete: [],
            veiculosInicias: [],
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
            revenda: {},
        }

        this.mounted = false;
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        scrollToTop();

        this.unsubscribeFunctions = [];

        fetchRevenda(id_firebase, this.setState.bind(this));

        subscribeToCollection(
            "veiculos",
            {
                filters: [
                    ["veremovido", "==", 0],
                    ["vevendido", "==", 0]
                ],
                orderBy: "updated_at",
                stateKey: "veiculos",
                processDoc: (document) => (document["veexibir_site"] !== false ? document : null),
            },
            (state) => {
                this.setState({
                    veiculos: state.veiculos,
                    veiculosComplete: state.veiculos,
                    veiculosInicias: state.veiculos
                });
            },
            this.unsubscribeFunctions
        );

        if (window && window.jQuery) {
            const $ = window.jQuery;
            const initRev = () => {
                if ($ && $.fn && $.fn.revolution && $("#rev_slider_3_1").length) {
                    $("#rev_slider_3_1").show().revolution({
                        sliderType: "standard",
                        sliderLayout: "auto",
                        delay: 5000,
                        navigation: {
                            arrows: { enable: true },
                            bullets: { enable: false }
                        },
                        gridwidth: 1170,
                        gridheight: 750,
                        disableProgressBar: "on"
                    });
                }
            };
            setTimeout(initRev, 0);
        }
    }

    componentWillUnmount() {
        this.unsubscribeFunctions.forEach(unsubscribe => unsubscribe());
    }

    handleSubmit(event) {
        event.preventDefault();

        const filtro = this.state.buscaVeiculo.toLowerCase().trim();
        const tipoVeiculo = this.state.tipoVeiculo;

        const veiculosFilter = this.state.veiculosInicias.filter(veiculo => {
            const descricaoVeiculo = veiculoUtils.getDescricaoVeiculo(veiculo);

            if (veiculoUtils.isNovo(tipoVeiculo)) {
                return veiculoUtils.isNovoVeiculo(veiculo, descricaoVeiculo, filtro);
            }

            if (veiculoUtils.isSeminovo(tipoVeiculo)) {
                return veiculoUtils.isSeminovoVeiculo(veiculo, descricaoVeiculo, filtro);
            }

            return descricaoVeiculo.includes(filtro);
        });

        this.setState({
            veiculos: veiculosFilter
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleClick() {
        this.setState({
            veiculos: this.state.veiculosComplete,
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
        });
    }

    render() {
        const {
            veiculos,
            tipoVeiculo,
        } = this.state;

        if (this.state.revenda.ativo === 0) {
            return (
                <div style={{ textAlign: "center" }}>
                    <h1>Site em manutenção.</h1>
                    <h3>Contate o suporte para mais detalhes (suporte@intermedioveiculos.com.br)</h3>
                </div>
            )
        }

        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />

                <div
                    id="rev_slider_3_1_wrapper"
                    className="rev_slider_wrapper fullwidthbanner-container rev_slider_3_1_wrapper"
                    data-alias="car-dealer-05"
                    data-source="gallery"
                >

                    <div
                        id="rev_slider_3_1"
                        className="rev_slider fullwidthabanner"
                        style={{ display: "none" }}
                        data-version="5.3.0.2"
                    >
                        <ul>

                            <li
                                data-index="rs-4"
                                data-transition="random-static,random-premium,random"
                                data-slotamount="default,default,default,default"
                                data-hideafterloop="0"
                                data-hideslideonmobile="off"
                                data-randomtransition="on"
                                data-easein="default,default,default,default"
                                data-easeout="default,default,default,default"
                                data-masterspeed="default,default,default,default"
                                data-thumb="images/testimonial/img01.jpeg"
                                data-rotate="0,0,0,0"
                                data-saveperformance="off"
                                data-title="Slide"
                                data-param1=""
                                data-param2=""
                                data-param3=""
                                data-param4=""
                                data-param5=""
                                data-param6=""
                                data-param7=""
                                data-param8=""
                                data-param9=""
                                data-param10=""
                                data-description=""
                            >
                                <img
                                    src="images/testimonial/img01.jpeg"
                                    alt=""
                                    data-bgposition="center center"
                                    data-bgfit="contain"
                                    data-bgrepeat="no-repeat"
                                    className="rev-slidebg"
                                    data-no-retina
                                />

                                <div
                                    className="tp-caption button red slide-4-layer-4"
                                    id="slide-4-layer-4"
                                    data-x="62"
                                    data-y="430"
                                    data-width="['auto']"
                                    data-height="['auto']"
                                    data-type="button"
                                    data-responsive_offset="on"
                                    data-frames='[{"delay":1720,"speed":2000,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:[100%];s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"nothing"},{"frame":"hover","speed":"300","ease":"Linear.easeNone","force":true,"to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgba(0, 0, 0, 1.00);bg:rgba(255, 255, 255, 1.00);bs:solid;bw:0 0 0 0;"}]'
                                    data-textalign="['left','left','left','left']"
                                    data-paddingtop="[10,10,10,10]"
                                    data-paddingright="[30,30,30,30]"
                                    data-paddingbottom="[10,10,10,10]"
                                    data-paddingleft="[30,30,30,30]"
                                ></div>
                            </li>

                            <li
                                data-index="rs-4"
                                data-transition="random-static,random-premium,random"
                                data-slotamount="default,default,default,default"
                                data-hideafterloop="0"
                                data-hideslideonmobile="off"
                                data-randomtransition="on"
                                data-easein="default,default,default,default"
                                data-easeout="default,default,default,default"
                                data-masterspeed="default,default,default,default"
                                data-thumb="images/testimonial/img02.jpeg"
                                data-rotate="0,0,0,0"
                                data-saveperformance="off"
                                data-title="Slide"
                                data-param1=""
                                data-param2=""
                                data-param3=""
                                data-param4=""
                                data-param5=""
                                data-param6=""
                                data-param7=""
                                data-param8=""
                                data-param9=""
                                data-param10=""
                                data-description=""
                            >
                                <img
                                    src="images/testimonial/img02.jpeg"
                                    alt=""
                                    data-bgposition="center center"
                                    data-bgfit="contain"
                                    data-bgrepeat="no-repeat"
                                    className="rev-slidebg"
                                    data-no-retina
                                />

                                <div
                                    className="tp-caption button red slide-4-layer-4"
                                    id="slide-4-layer-4"
                                    data-x="62"
                                    data-y="430"
                                    data-width="['auto']"
                                    data-height="['auto']"
                                    data-type="button"
                                    data-responsive_offset="on"
                                    data-frames='[{"delay":1720,"speed":2000,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:[100%];s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"nothing"},{"frame":"hover","speed":"300","ease":"Linear.easeNone","force":true,"to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgba(0, 0, 0, 1.00);bg:rgba(255, 255, 255, 1.00);bs:solid;bw:0 0 0 0;"}]'
                                    data-textalign="['left','left','left','left']"
                                    data-paddingtop="[10,10,10,10]"
                                    data-paddingright="[30,30,30,30]"
                                    data-paddingbottom="[10,10,10,10]"
                                    data-paddingleft="[30,30,30,30]"
                                ></div>
                            </li>

                            <li
                                data-index="rs-4"
                                data-transition="random-static,random-premium,random"
                                data-slotamount="default,default,default,default"
                                data-hideafterloop="0"
                                data-hideslideonmobile="off"
                                data-randomtransition="on"
                                data-easein="default,default,default,default"
                                data-easeout="default,default,default,default"
                                data-masterspeed="default,default,default,default"
                                data-thumb="images/testimonial/img03.jpeg"
                                data-rotate="0,0,0,0"
                                data-saveperformance="off"
                                data-title="Slide"
                                data-param1=""
                                data-param2=""
                                data-param3=""
                                data-param4=""
                                data-param5=""
                                data-param6=""
                                data-param7=""
                                data-param8=""
                                data-param9=""
                                data-param10=""
                                data-description=""
                            >
                                <img
                                    src="images/testimonial/img03.jpeg"
                                    alt=""
                                    data-bgposition="center center"
                                    data-bgfit="contain"
                                    data-bgrepeat="no-repeat"
                                    className="rev-slidebg"
                                    data-no-retina
                                />

                                <div
                                    className="tp-caption button red slide-4-layer-4"
                                    id="slide-4-layer-4"
                                    data-x="62"
                                    data-y="430"
                                    data-width="['auto']"
                                    data-height="['auto']"
                                    data-type="button"
                                    data-responsive_offset="on"
                                    data-frames='[{"delay":1720,"speed":2000,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:[100%];s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"nothing"},{"frame":"hover","speed":"300","ease":"Linear.easeNone","force":true,"to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgba(0, 0, 0, 1.00);bg:rgba(255, 255, 255, 1.00);bs:solid;bw:0 0 0 0;"}]'
                                    data-textalign="['left','left','left','left']"
                                    data-paddingtop="[10,10,10,10]"
                                    data-paddingright="[30,30,30,30]"
                                    data-paddingbottom="[10,10,10,10]"
                                    data-paddingleft="[30,30,30,30]"
                                ></div>
                            </li>
                        </ul>
                        <div
                            className="tp-bannertimer tp-bottom"
                            style={{ visibility: "hidden !important" }}
                        ></div>
                    </div>
                </div>


                <section className="product-listing page-section-ptb" style={{ paddingTop: "10px" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-8">
                                <ValidatorForm id="contactForm" className="s-form wow zoomInUp" ref="form" onSubmit={this.handleSubmit} >
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="col-lg-6">
                                                <TextValidator placeholder="Ex.: Fiat Palio"
                                                    label="Encontre seu carro"
                                                    onChange={this.handleChange}
                                                    name="buscaVeiculo"
                                                    value={this.state.buscaVeiculo}
                                                    className="form-ui-bootstrap" />

                                            </div>

                                            <div className="col-lg-3" style={{ paddingTop: "44px" }}>
                                                <SelectValidator
                                                    value={tipoVeiculo}
                                                    name="tipoVeiculo"
                                                    className="form-ui-bootstrap select-busca-veiculos"
                                                    onChange={this.handleChange}>
                                                    <MenuItem value="todos">Todos</MenuItem>
                                                    <MenuItem value="novos">0 Km</MenuItem>
                                                    <MenuItem value="seminovos">Seminovos</MenuItem>
                                                </SelectValidator>
                                            </div>

                                            <div className="col-lg-3 text-center" style={{ paddingTop: "30px" }}>
                                                <button type="submit" className="btn m-btn">BUSCAR CARROS<span className="fa fa-angle-right"></span></button><br />
                                                <p className="linkLimparBusca text-center" onClick={this.handleClick} style={{ color: "#362e88" }}>LIMPAR BUSCA</p>
                                            </div>
                                        </div>
                                    </div>
                                </ValidatorForm>

                                <div className="row">
                                    {Object.keys(veiculos)
                                        .map(key => {
                                            return (
                                                <div className="col-lg-4" data-wow-delay="0.5s" key={veiculos[key].id}>
                                                    <Link to={"/veiculo/" + veiculos[key].id}>
                                                        <div className="car-item gray-bg text-center">
                                                            <div className="car-image">
                                                                {
                                                                    veiculos[key].imagens.length > 0 ?
                                                                        veiculos[key].imagens[0].fileThumb !== undefined ?
                                                                            <img className="img-fluid" src={veiculos[key].imagens[0].fileThumb} alt=""></img>
                                                                            :
                                                                            <img className="img-fluid" src={veiculos[key].imagens[0].fileUrl} alt=""></img>
                                                                        : <img className="img-fluid" src="/images/car_default.png" alt='imagem veículo'></img>
                                                                }

                                                                <div className="car-overlay-banner botaoShare-box"></div>
                                                            </div>
                                                            <div className="car-list">
                                                                <ul className="list-inline">
                                                                    <li><i className="fa fa-registered"></i>{this.state.veiculos[key].veano_fabricacao}/{this.state.veiculos[key].vefipe_ano_modelo}</li>
                                                                    <li><i className="fa fa-cog"></i>{formatCambio(veiculos[key].vecambio)}</li>
                                                                    <li><i className="fa fa-dashboard"></i>{veiculos[key].vequilometragem} KM</li>
                                                                </ul>
                                                            </div>
                                                            <div className="car-content">
                                                                <span style={{ color: "#34383d" }}>{veiculos[key].veano_fabricacao}/{veiculos[key].vefipe_ano_modelo}</span>
                                                                <div className="separator"></div>
                                                                <Link to={"/veiculo/" + veiculos[key].id}>
                                                                    {veiculos[key].vefipe_marca} {veiculos[key].vefipe_name}
                                                                </Link>
                                                                <div className="price">
                                                                    <span className="new-price">{formatMoney(veiculos[key].vevalor)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="welcome-3 white-bg page-section-ptb">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="feature-box-2 box-hover">
                                    <div className="icon" style={{ display: "flex", justifyContent: "center" }}>
                                        <i className="glyph-icon flaticon-car"></i>
                                    </div>
                                    <div className="content">
                                        <h5 style={{ textAlign: "center" }}>Todas as marcas</h5>
                                        <p>
                                            Nós oferecemos uma ampla variedade de marcas de carros de alta qualidade, para atender a todas as necessidades e estilos de direção.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="feature-box-2 box-hover">
                                    <div className="icon" style={{ display: "flex", justifyContent: "center" }}>
                                        <i className="glyph-icon flaticon-interface-1"></i>
                                    </div>
                                    <div className="content">
                                        <h5 style={{ textAlign: "center" }}>Atendimento</h5>
                                        <p>Nós priorizamos sempre o bem-estar e satisfação de nossos clientes, oferecendo um atendimento excepcional e personalizado. Confira nossas redes sociais e nosso atendimento on-line!</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="feature-box-2 box-hover">
                                    <div className="icon" style={{ display: "flex", justifyContent: "center" }}>
                                        <i className="glyph-icon flaticon-key"></i>
                                    </div>
                                    <div className="content">
                                        <h5 style={{ textAlign: "center" }}>Venda seu carro</h5>
                                        <p>
                                            Venda seu carro com confiança, sabendo que estamos oferecendo um preço justo.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="feature-box-2 box-hover">
                                    <div className="icon" style={{ display: "flex", justifyContent: "center" }}>
                                        <i className="glyph-icon flaticon-wallet"></i>
                                    </div>
                                    <div className="content">
                                        <h5 style={{ textAlign: "center" }}>Financiamento</h5>
                                        <p>
                                            Nós ajudamos você a realizar o sonho de possuir um carro novo, com opções flexíveis e acessíveis de financiamento para atender a todas as necessidades, buscamos sempre as menores taxas de juros para nossos clientes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <hr className="gray"></hr>
                <section className="latest-blog gray-bg page-section-ptb" id='empresa'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12" >
                                <div className="section-title empresa" >
                                    <h2>Nossa Loja</h2>

                                    <div className="separator"></div>
                                </div>
                            </div>
                        </div>
                        <div className="row empresaImg">
                            <div className="col-lg-4 col-md-12">
                                <div className="blog-2">
                                    <div className="blog-image">
                                        <img
                                            className="img-fluid"
                                            src="images/trimestrais/01.jpeg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className="blog-2">
                                    <div className="blog-image">
                                        <img
                                            className="img-fluid"
                                            src="images/trimestrais/02.jpeg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-12">
                                <div className="blog-2">
                                    <div className="blog-image">
                                        <img
                                            className="img-fluid"
                                            src="images/trimestrais/03.jpeg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Rodape revenda={this.state.revenda} />
            </div >
        )
    }
}

export default Inicio